const videoPlayer = function() {
    /*
     * Based on https://github.com/sampotts/plyr
     */

    const defaults = {
        selectors: {
            container: ".videoPlayer",
            player: ".videoPlayer-player",
        },
        settings: {
            player: {
                controls: ['play-large', 'mute', 'airplay', 'fullscreen'],
                ratio: '16:9',
                vimeo: {
                    dnt: true,
                }
            },
        }
    };

    function init() {

        // const player = new Plyr('#player', {
        //     controls: ['play-large', 'mute', 'airplay', 'fullscreen'],
        // });

        const containers = document.querySelectorAll(defaults.selectors.container);

        for (let i = 0; i < containers.length; i++) {
            new VideoPlayer(containers[i])
        }

    }

    function pauseAllPlayers() {

        const event = new CustomEvent(
            "videoPlayer:stop"
        );

        document.dispatchEvent(event);

    }

    const VideoPlayer = function(parent) {

        const container = parent.querySelector(defaults.selectors.player);

        this.isPlaying = false;

        this.player = new Plyr(container, defaults.settings.player);

        this.player.on('playing', event => {

            if (! this.isPlaying) {
                pauseAllPlayers();
            }

            this.isPlaying = true;

        });

        document.addEventListener(
            'videoPlayer:stop',
            (event) => {
                this.stop();
            },
            false
        );

    }

    VideoPlayer.prototype.stop = function() {

        if (! this.isPlaying) {
            return;
        }

        this.player.pause();
        this.isPlaying = false;

    }

    return {
        init: init
    }

}();

videoPlayer.init();
